import { ReactNode } from 'react';
import { animated, config, useTransition } from 'react-spring';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  isolation: isolate;
  & > * {
    position: absolute;
    top: 0;
    white-space: nowrap;
    &:nth-child(1) {
      position: unset;
    }
  }
`;

type Props = {
  children: ReactNode;
  trigger: string | number | boolean;
};

export const Impact = ({ children, trigger }: Props) => {
  const transitions = useTransition(trigger, {
    initial: null,
    from: {
      opacity: 0,
      transform: 'scale(0.5)',
    },
    enter: {
      opacity: 1,
      transform: 'scale(1)',
    },
    config: config.wobbly,
  });

  return (
    <Wrapper>
      {transitions((style, item) => (
        <animated.div style={style} key={item?.toString()}>
          {children}
        </animated.div>
      ))}
    </Wrapper>
  );
};
